import React from "react";
import Sidebar from "./Sidebar";
import KunggyIntro from "./kunggy_module";
import SidebarMenu from "./SidebarMenu";

const Tutorial = () => {
  return (
    <main className="flex w-full box-border overflow-hidden m-0 p-0 h-[100vh]">
      <div className="">
        <Sidebar>
          <SidebarMenu />
        </Sidebar>
      </div>
      <div className="w-full py-4 px-6 overflow-y-auto">
        <KunggyIntro />
      </div>
    </main>
  );
};

export default Tutorial;
